import { InjectionToken } from '@angular/core';

import { BetslipType } from 'packages/sports/common/betslip/core/betslip-type';
import { Observable } from 'rxjs';

import { SlipId } from '../../../bet-generation/models';
import { RewardTokenContext } from '../../../reward-tokens/reward-tokens.model';
import { InfoTrackingContext } from '../../../tracking/models';
import { BetslipError } from '../../../validation/errors/betslip-error';

export const LINEAR_COMBO_BET_CONTAINER_SERVICE_INJECTION_TOKEN = new InjectionToken<ILinearComboBetContainerService>(
    'LINEAR_COMBO_BET_CONTAINER_SERVICE',
);

export interface LinearComboBetContainerViewModel {
    placeablePicksCount: number;
    errors: BetslipError[];
    hasComboPrevention: boolean;
    totalPicksCount: number;
    multiTitleBadge: SgpBadgeType | undefined;
    multiTitle: string;
    subTitle?: string;
    isPickAreaExpandable: boolean;
    isRewardSelectorVisible: boolean;
    isErrorVisible: boolean;
    isEachWay: boolean;
    isEpcotEnabled: boolean;
    showInfoIcon: boolean;
    showEachWayToggle: boolean;
    tokenContext: RewardTokenContext;
    betslipType: BetslipType;
    slipId: SlipId;
    showRemoveButton: boolean;
    showDetailsSection: boolean;
    showSelectionCounter: boolean;
    infoMessage: string;
    infoHeaderTitle: string;
    infoHeader: string;
    infoTrackingContext: InfoTrackingContext.ComboBet | InfoTrackingContext.Sgp | InfoTrackingContext.SgpPlus;
    isTotalOddsIndicatorEnabled: boolean;
    showTokenSummaryUnderTitle: boolean;
}

export interface ILinearComboBetContainerService {
    viewModel$: Observable<LinearComboBetContainerViewModel | null>;
    isExpandedByDefault: boolean;

    toggleEachWay(isEachWay: boolean): void;
    toggleExpansion(isExpanded: boolean): void;
    remove(): void;
}

export enum SgpBadgeType {
    Sgp = 'sgp',
    SgpPlus = 'sgp+',
}
